/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject} from '@angular/core';
import template from './site-group-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {getListChildren} from '../common/controller/resource-list-utils';
import {OBJECT_TYPE} from '../common/constants/object-type';
import {SiteResource} from '../../components/api/resources/resource/site.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-site-group-list-page',
  template
})
export class SiteGroupListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.inv.site-groups.site-group';
  readonly siteItemStateName = 'app.inv.sites.site';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'}
  ];

  readonly childColumns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'siteUrl', labelInstant: 'Site URL'}
  ];

  showOwnerColumn = false;

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly adnListHelper: AdnListHelperService,
    @Inject(SiteResource) private readonly Site: any
  ) {
    super(LocalNetworkProfile);
    this.showOwnerColumn = LocalNetworkProfile.isPureMarketplacePlatform();
    if (this.showOwnerColumn) {
      this.columns = [
        ...this.columns,
        {param: 'OwnerTeam', labelInstant: 'Owner', sortable: false}
      ];
    }
  }

  get sortHeaderParams(): AdminListColumn[] {
    return this.columns;
  }

  toggleChildren(siteGroup: any): void {
    this.list.getChildren?.(siteGroup);
  }

  childList(siteGroupId: string): any {
    return this.list.children?.[siteGroupId];
  }

  ownerLabel(siteGroup: any): string {
    return siteGroup.ownerTeam?.name || 'Network';
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    this.list.canExpand = true;
    if (!this.list.getChildren) {
      getListChildren(this.list, this.adnListHelper, OBJECT_TYPE.SiteGroup, this.Site);
    }
  }
}
